var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCocos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.968 3.892c-1.282 1.124-3.715 3.432-5.193 5.457-1.523 2.086-2.318 4.917-2.564 6.257l6.22 9.203 6.121-1.616L14.97 3.892zm4.72 19.88.18.756-1.54 5.282a7.69 7.69 0 0 1-1.392.19l-3.154-4.669 5.906-1.558zm.458 1.925.728 3.066c-.298.168-.607.328-.93.481a8.09 8.09 0 0 1-.943.378l1.146-3.925zm1.263 2.75-.928-3.904.31-1.062 6.129-1.617c-.488 1.544-2.12 4.48-5.511 6.584zm-1.284-5.405L15.268 2.585V2c1.336.99 4.29 3.355 5.42 4.9.959 1.313 2.308 3.077 3.117 4.123l-3.49 11.97-.19.05zM6.028 14.917 12.82 24.97l-3.967 1.048c-1.009-1.214-1.733-2.578-2.048-3.9-.796-3.344-.86-5.988-.777-7.201zm3.263 11.6 3.883-1.025L16.22 30c-2.656-.125-5.15-1.566-6.93-3.483zm11.696-3.702 4.883-1.289c.107-1.11.261-2.96.31-4.53.06-1.9-1.064-5.049-1.633-6.385l-.012.03-3.55 12.175z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCocos);
export default __webpack_public_path__ + "static/media/COCOS.afa471e9f296fa5507dc086d40c9ae23.svg";
export { ForwardRef as ReactComponent };